module.exports = __webpack_public_path__ + "img/logo.14c224a8.svg";